import React from 'react';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  tag: {
    color: '#212121',
    'font-size': '12px',
    'line-height': '17px',
    textDecoration: 'none',
    'box-sizing': 'border-box',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    'border-radius': '2px',
    padding: '0 5px'
  },
  tagsContainer: {
    display: 'flex',
    gap: '5px',
    flexWrap: 'wrap',
    padding: '5px 0'
  }
});
/**
 * Render a list of tags.
 *
 * The <TagsField> component accepts the following props:
 *
 * - hasRecord {boolean} - must be false if not used in a react-admin context
 * - record  {object} - react admin object, passed through the ListContextProvider
 * - tagType {string} - name of the tag property in the record
 * - tags {object} - { tagId1: tagName1, ...} (not needed in a react-admin context)
 *
 *
 * @example
 * // React-Admin
 * const FundList = (props) => (
 *   <List {...props} title="List of funds">
 *       <Datagrid>
 *           <LinkField label="Fund Name" source="name" id="fund name" />
 *           <TextField label="A.K.A." source="aka" id="fund aka" />
 *           <TagsField label="Fund Tags" source="fundtags" tagType="fundTags"/>
 *       </Datagrid>
 *   </List>
 * );
 *
 *
 * @example
 * // If not used with react-admin, you must provide an object that will contain the tags:
 * const CustomComponent = () => {
 *   const tags = {
 *    tagID1: 'tagName1',
 *    tagID2: 'tagName2,
 *   };
 *
 *   return <TagFields fundTags={tags} />
 *
 * };
 */

const TagsField = ({ hasRecord = true, record, tagType, tags = {} }) => {
  const classes = useStyles();
  const tagArray = [];

  if (hasRecord && record) {
    Object.entries(record[tagType])
      .sort((a, b) => a[1].localeCompare(b[1]))
      .forEach(([key, value]) => tagArray.push({ id: key, value }));
  } else {
    Object.entries(tags).forEach(([key, value]) =>
      tagArray.push({ id: key, value })
    );
  }

  if (tagArray.length > 0) {
    return (
      <div className={classes.tagsContainer}>
        {tagArray.map(tag => (
          <span key={tag.id} className={classes.tag}>
            {tag.value}
          </span>
        ))}
      </div>
    );
  }
  return null;
};

export default TagsField;
